<template>
  <v-dialog v-model="weighInVisible" max-width="500">
    <validation-observer v-slot="{ invalid }">
      <v-card class="text-center">
        <v-card-title>
          New Weigh-In
          <v-spacer />

          <v-icon aria-label="Close" @click="setWeighInModal(false)">mdi-close</v-icon>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                v-model="datepicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <validation-provider rules="required" v-slot="{ errors }">
                    <v-text-field
                      :error-messages="errors"
                      
                      :value="date | moment('DD MMMM YYYY')"
                      label="Date"
                      append-icon="mdi-calendar"
                      hint="Date for this weigh-in"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </validation-provider>
                </template>
                <v-date-picker v-model="date" no-title @input="datepicker=false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <validation-provider rules="requiredNumeric" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  label="Weight"
                  :suffix="profile.u"
                  type="number"
                  hint="Your current weight"
                  v-model="weight"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="gray" text @click="setWeighInModal(false)">Cancel</v-btn>
          <v-btn type="submit" color="primary" @click="weighIn" :disabled="invalid" :loading="busy">Save</v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>


  </v-dialog>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      date: '',
      weight: '',
      busy: false,
      datepicker: false,
    };
  },
  computed: {
    ...mapState("Ui", ["showWeighInModal"]),
    ...mapState("Profile", ["profile"]),
    weighInVisible: {
        get: function() {
          return this.showWeighInModal
        },
        set: function() {
          this.setWeighInModal(false)
        }
      }
  },
  methods: {
    ...mapMutations("Ui", ["setWeighInModal", 'showSnackbar' ]),
    ...mapActions('Diary', ["addWeight"]),
    weighIn() {
      this.busy = true;
      this.addWeight({w: this.weight, d: this.date})
      .then(() => {
        // success
        this.setWeighInModal(false);
        this.showSnackbar({
          snackbarType: 'success',
          snackbarMessage: 'You have been weighed in successfully',
        });
      })
      .catch(() => {
        // error
        this.showSnackbar({
          snackbarType: 'error',
          snackbarMessage: 'There was an error weighing you in.  Please try again.',
        });
      })
      .finally(() => this.busy = false)
    }
  },
};
</script>
<style scoped>
.v-picker--date {
  margin-top: 0;
  margin-bottom: 0;
}
</style>